import { AxiosInstance } from 'axios'
import { InjectionKey } from '@vue/composition-api'

export class CommentaryApi {
  constructor(private client: AxiosInstance, private uri: string) {}

  private path(path: string): string {
    return this.uri + path
  }

  GetCommentary(
    conversationId: number,
    firstPartyLabel: string,
    secondPartyLabel: string,
    model: string,
    scores: any
  ) {
    return this.client
      .post(this.path(`/${conversationId}`), {
        firstPartyLabel,
        secondPartyLabel,
        model,
        scores
      })
      .then(response => {
        return response?.data || []
      })
  }
}

export const CommentaryApiKey: InjectionKey<CommentaryApi> = Symbol()
